import { z } from 'zod';

// ── AI-assisted reconciliation: auto-clear from a statement ─────────────────

export const aiClearFromStatementInputSchema = z.object({
  statementId: z.string().uuid(),
});
export type AiClearFromStatementInput = z.infer<typeof aiClearFromStatementInputSchema>;

export interface AiClearSuggestion {
  journalEntryId: string;
  entryNumber: string;
  date: string;
  /** Signed against the GL account's normal balance — positive = money into the account. */
  signedAmount: string;
  description: string;
  /** 0.0-1.0 — the model's reported confidence. */
  confidence: number;
  /** One short sentence from the model explaining the match. */
  reasoning: string;
}

export interface AiClearResult {
  suggestions: AiClearSuggestion[];
  /** Lines the model thought were transactions but couldn't match to a candidate. */
  unmatchedStatementLines: string[];
  /** True when the model's response wasn't parseable; suggestions will be empty. */
  parseError?: string;
}
